import { ReqHeader } from './header-req.model';

export class ReqModel {

  header: ReqHeader;
  body: any;

  constructor(currentLang?: string) {
    this.header = new ReqHeader();
  }
}
